/**
 * Collects diagnostic information about the Stripe loading environment.
 * Attached to Sentry events via log()'s meta parameter to help cluster
 * failure causes (adblockers, network issues, CSP violations, etc.).
 */
export function collectStripeDiagnostics(): Record<string, unknown> {
  const diagnostics: Record<string, unknown> = {
    online: navigator.onLine,
  }

  if (typeof performance !== "undefined" && performance.getEntriesByType) {
    const resources = performance.getEntriesByType(
      "resource"
    ) as PerformanceResourceTiming[]
    const stripeResources = resources
      .filter((r) => r.name.includes("js.stripe.com"))
      .map((r) => ({
        name: r.name,
        duration: r.duration,
        transferSize: r.transferSize,
        startTime: r.startTime,
      }))
    diagnostics.stripeResources = stripeResources
    diagnostics.stripeResourceCount = stripeResources.length
  }

  return diagnostics
}
